import { i18n as _i18n } from "@lingui/core";
import { useLingui } from '@lingui/react';
import { CarleadCreationButton, CarleadCreationForm, CarleadMileageFormatted, defaultCarleadSplitFlow, Email, EmailConsent, QuestionnaireBoxSelect, QuestionnaireSelect, renderFieldVerticalWrapper, SplitBodyTypes, SplitDoorCount, SplitFuelType, SplitGearType, SplitHorsePower, SplitMainTypeDetails, SplitMainTypesSub, useCreateCarleadChainedRequest, useCreateConsumerCarleadRequestChain, useCreateEmailConsentProps, useCreateNormalCarleadForm, useFormQuestionnaireProps, useSplitFieldsFlowService, useSplitFieldsProps,
//
carleadQuestionnaireWithTradeInPartialFlow } from '@wkda/carlead-creation-components';
import { useTrackLanding } from '@wkda/funnel-components';
import { Paper } from '@wkda/styleguide';
import { ReturningCustomerPopup, TermsAndConditions, TrustPilot } from '../../../../../components';
import React from 'react';
import { carleadQuestionnaireWithBuyCarQuestionPartialFlow } from '../../../../../constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Step2BuyCarConsentCustomerPopup = _ref => {
  let {
    wide = false
  } = _ref;
  const flow = {
    ...defaultCarleadSplitFlow,
    ...carleadQuestionnaireWithBuyCarQuestionPartialFlow
  };
  const emailConsentProps = useCreateEmailConsentProps();
  const questionnaireProps = useFormQuestionnaireProps(flow);
  const splitFieldsProps = useSplitFieldsProps();
  const machine = useSplitFieldsFlowService(flow);
  const request = useCreateCarleadChainedRequest([
  // make this the last one
  useCreateConsumerCarleadRequestChain()]);
  const consumerForm = useCreateNormalCarleadForm([questionnaireProps, emailConsentProps, splitFieldsProps]);
  const {
    i18n
  } = useLingui();
  useTrackLanding();
  const trustpilotBoxDesktopConfig = {
    className: 'trustpilot-widget trustpilot-widget--box',
    templateId: '5419b6ffb0d04a076446a9af'
  };
  const trustpilotBoxMobileConfig = {
    className: 'trustpilot-widget trustpilot-widget--box',
    templateId: '5419b732fbfb950b10de65e5'
  };
  return /*#__PURE__*/_jsxs(Paper, {
    className: "carlead-creation-form__container step-2",
    children: [/*#__PURE__*/_jsx(ReturningCustomerPopup, {}), /*#__PURE__*/_jsx("div", {
      className: "box gap full-height",
      children: /*#__PURE__*/_jsxs("div", {
        className: `container ${wide ? 'container-xl' : ''}`,
        children: [/*#__PURE__*/_jsx("h1", {
          className: "carlead-creation-form__title",
          dangerouslySetInnerHTML: {
            __html: i18n._('carleadCreation.form.step2.headline')
          }
        }), /*#__PURE__*/_jsxs(CarleadCreationForm, {
          carleadForm: consumerForm,
          options: {
            name: 'StepCompound'
          },
          machineService: machine,
          submitHandler: request,
          children: [/*#__PURE__*/_jsx(SplitBodyTypes, {}), /*#__PURE__*/_jsx(SplitFuelType, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitMainTypeDetails, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitHorsePower, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitGearType, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitDoorCount, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(SplitMainTypesSub, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(CarleadMileageFormatted, {
            lowerThreshold: 2500,
            upperThreshold: 35000,
            suspiciousMileageMessageDelay: 2000,
            isHiddenField: true,
            renderFieldWrapper: renderFieldVerticalWrapper
          }), /*#__PURE__*/_jsx(QuestionnaireSelect, {
            renderFieldWrapper: renderFieldVerticalWrapper,
            name: "SELLPOINT",
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.form.label.sellpoint'
            }),
            isHiddenField: true,
            answers: [{
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpointNow'
              }),
              value: 'SELLPOINT_NOW'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpoint4weeks'
              }),
              value: 'SELLPOINT_4_WEEKS'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpoint3months'
              }),
              value: 'SELLPOINT_3_MONTHS'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellpointNotPlanned'
              }),
              value: 'SELLPOINT_NOT_PLANNED'
            }]
          }), /*#__PURE__*/_jsx(QuestionnaireSelect, {
            renderFieldWrapper: renderFieldVerticalWrapper,
            name: "SELL_TYPES",
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.form.label.sellTypes'
            }),
            isHiddenField: true,
            answers: [{
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellTypesPrivate'
              }),
              value: 'PRIVATE'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.sellTypesDealer'
              }),
              value: 'DEALER'
            }]
          }), /*#__PURE__*/_jsx(QuestionnaireBoxSelect, {
            renderFieldWrapper: renderFieldVerticalWrapper,
            name: "BUY_CAR",
            isHiddenField: true,
            label: _i18n._(
            /*i18n*/
            {
              id: 'carleadCreation.form.label.buyCar'
            }),
            answers: [{
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.buyCarYES'
              }),
              value: 'YES'
            }, {
              label: _i18n._(
              /*i18n*/
              {
                id: 'carleadCreation.option.buyCarNO'
              }),
              value: 'NO'
            }]
          }), /*#__PURE__*/_jsx(Email, {
            isHiddenField: true,
            renderFieldWrapper: renderFieldVerticalWrapper
          }), /*#__PURE__*/_jsx(EmailConsent, {
            isHiddenField: true
          }), /*#__PURE__*/_jsx(TermsAndConditions, {}), /*#__PURE__*/_jsx(CarleadCreationButton, {})]
        }), /*#__PURE__*/_jsxs("section", {
          className: "trust-box",
          children: [/*#__PURE__*/_jsx("div", {
            className: "d-none d-lg-block",
            children: /*#__PURE__*/_jsx(TrustPilot, {
              overrideConfig: trustpilotBoxDesktopConfig
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "d-block d-lg-none",
            children: /*#__PURE__*/_jsx(TrustPilot, {
              overrideConfig: trustpilotBoxMobileConfig
            })
          })]
        })]
      })
    })]
  });
};
export default Step2BuyCarConsentCustomerPopup;